import React, { FC } from 'react'
import { Route, Routes } from 'react-router-dom'
import { WebRoute } from '../routes'
import { Layout } from '../layout'
import { LoginSuccess } from './Login/LoginSuccess'
import { LogoutSuccess } from './Logout/LogoutSuccess'
import { ResetConfirmation } from './Login/ResetConfirmation'

const NotFound = React.lazy(() => import('./NotFound'))

const CreateAccount = React.lazy(() => import('./CreateAccount'))
const CreateAccountConfirmation = React.lazy(
  () => import('./CreateAccount/CreateAccountConfirmation'),
)
const ResetPasswordPage = React.lazy(() => import('./Login/ResetPassword'))



const ForgotPassword = React.lazy(() => import('./ForgotPassword/ForgotPassword'))
const ForgotPasswordSubmitted = React.lazy(() => import('./ForgotPassword/ForgotPasswordSubmitted'))


export const Main: FC = () => (
  <Routes>
    <Route element={<LoginSuccess />} path={WebRoute.LOGIN_SUCCESS} />
    <Route element={<LogoutSuccess />} path={WebRoute.LOGOUT_SUCCESS} />
    <Route element={<ResetPasswordPage />} path={WebRoute.RESET_PASSWORD + '/*'} />

    <Route element={<ResetConfirmation />} path={WebRoute.RESET_PASSWORD_CONFIRMATION + '/*'} />
    <Route element={<CreateAccount />} path={WebRoute.REGISTER} />
    <Route element={<CreateAccountConfirmation />} path={WebRoute.ACCOUNT_CREATED} />
    <Route element={<ForgotPassword />} path={WebRoute.FORGOT_PASSWORD} />
    <Route element={<ForgotPasswordSubmitted />} path={WebRoute.FORGOT_PASSWORD_SUBMITTED + '/*'} />

    <Route element={<Layout><NotFound /></Layout>} path='/*' />
  </Routes>
)
